// Signed video URLs are temporary capabilities, not permanent media addresses.
// R2's private signer issues one-hour GET URLs. Refresh significantly earlier,
// while preserving the legacy Supabase signed-URL lifetime (24 hours).
export const R2_VIDEO_URL_CACHE_MS=45*60*1000;
export const LEGACY_VIDEO_URL_CACHE_MS=23*60*60*1000;

export function privateMediaCacheKey(row){
  return [row?.id||'',row?.media_path||'',row?.data?.r2UploadId||''].join(':');
}

export async function cachedPrivateMediaUrl(cache,row,fetchUrl,{force=false,now=Date.now}={}){
  if(!row||!cache||typeof fetchUrl!=='function')throw new Error('Video source is unavailable.');
  const key=privateMediaCacheKey(row);
  if(force)cache.delete(key);
  const existing=cache.get(key);
  if(existing?.url && existing.expires>now())return existing.url;
  cache.delete(key);
  const url=await fetchUrl(row,{force});
  if(typeof url!=='string'||!url.trim())throw new Error('Could not obtain a video playback link.');
  const duration=row?.data?.mediaProvider==='r2'?R2_VIDEO_URL_CACHE_MS:LEGACY_VIDEO_URL_CACHE_MS;
  cache.set(key,{url,expires:now()+duration});
  return url;
}
